import { render, staticRenderFns } from "./IssueStats.vue?vue&type=template&id=0dc176bd&"
import script from "./IssueStats.vue?vue&type=script&lang=js&"
export * from "./IssueStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports